/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";

// Soft UI Dashboard React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { transparent, dark } = colors;

const select = {
  styleOverrides: {
    select: {
      display: "grid",
      alignItems: "center",
      // the box's own padding is the left edge; this keeps the text off the arrow
      padding: `0 ${pxToRem(24)} 0 0 !important`,

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    /**
     * The stock theme hid the dropdown arrow entirely, which made every
     * select in the app look like a plain text box - there was nothing to
     * tell you it could be opened. Put it back.
     */
    icon: {
      display: "block",
      color: dark.main,
      right: pxToRem(8),
    },
  },
};

export default select;
